import { render } from "./Document.vue?vue&type=template&id=8d0d4f9c&scoped=true"
import script from "./Document.vue?vue&type=script&lang=js"
export * from "./Document.vue?vue&type=script&lang=js"

import "./Document.vue?vue&type=style&index=0&id=8d0d4f9c&scoped=true&lang=css"

import exportComponent from "/builds/angeloferraro/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d0d4f9c"]])

export default __exports__